import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const GetAllClubs = () => {
  const url = `${apiConstants.GetAllClubs}?SkipCount=0&MaxResultCount=100000`;

  return httpClient.get(url).then(result => result.data.result.items);
};

const GetClub = (id) => {
  const url = `${apiConstants.GetClub}?Id=${id}`;

  return httpClient.get(url).then(result => result.data.result.items);
};

export { GetAllClubs, GetClub };
